<template>
  <div class="filters-get-text" :class="{ 'button-loader': loading }">
    <template v-if="loading">
      {{ prefix }}
      <UiPButtonButtonLoader :type="loaderType" />
      товаров
    </template>
    <template v-else>
      {{ count ? `${prefix} ${wordEnd(count)}` : 'Ничего не найдено' }}
    </template>
  </div>
</template>

<script setup lang="ts">
import numWord from '~/common/num-word.js';
defineProps({
  loading: {
    type: Boolean,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  loaderType: {
    type: String,
    default: 'default',
    validator: (value: string) =>
      ['default', 'invert', 'black', 'grey'].includes(value),
  },
  prefix: {
    type: String,
    default: 'Найдено',
  },
});

const wordEnd = (val: number) =>
  numWord(val, ['', 'товар', 'товара', 'товаров'], true);
</script>

<style scoped lang="scss">
.filters-get-text {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  justify-content: center;

  .loader {
    margin: 0 8px;
    width: auto;
  }
  .button-loader {
    background: red !important;
  }
  @include md-block {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
